export default function checkForPartnerGroup () {
    try {
        for (let group of skilljarUserStudentGroups) {
            if (group.name.toLowerCase().includes('partner')) {
                return true;
            }
        }
    } catch (e) {
        console.warn('Error checking student group data:', e)
    }

    return false;
};
